import { Navigate as ReactRouterNavigate, type NavigateProps } from 'react-router-dom';
import { setAttemptedTransitionUrl } from '@customerio/hydra-nav-state';

interface NavigateWithTransitionUrlProps extends NavigateProps {
  /**
   * Whether to save the current URL before navigating.
   * When true, the current URL will be saved and can be used
   * to redirect back after authentication or other flows.
   */
  saveCurrentUrl?: boolean;
}

/**
 * A generic Navigate component that can optionally save the current URL
 * before redirecting. This is useful for auth flows where you want to
 * redirect back to the original page after login.
 */
export function Navigate({ saveCurrentUrl = false, ...props }: NavigateWithTransitionUrlProps) {
  if (saveCurrentUrl) {
    setAttemptedTransitionUrl(window.location.href);
  }
  return <ReactRouterNavigate {...props} />;
}
